import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import MusculaLog from '@muscula.com/muscula-webapp-js-logger';

if (environment.production) {
  enableProdMode();
  MusculaLog.Init('1371LEqQhnPk7');
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
